import getScrollAccessor from './getScrollAccessor';
/**
 * Gets or sets the scroll top position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */

export default getScrollAccessor('pageYOffset');


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/scrollTop.js
// module id = 299
// module chunks = 0